import * as React from "react";

const ThemesIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117 117" {...props}>
		<path d="M68.81 15.24c24.13.51 48.06 7.12 17.29 23.78-18.47 10 21.02 13.38 27.32 21.41 11.69 14.9-10.98 29.95-22.99 35.71-12.74 5.53-26.21 7.07-39.84 5.9-84.18-11.56-51.8-89.89 18.22-86.8Zm-8.67 60.94c-10.58-.93-11.18 15.98-.8 15.99 10.58.93 11.18-15.98.8-15.99Zm2.88-34.97c10.45.75 9.67-16.68.18-15.93-10.42-.08-11.61 16.17-.18 15.93Zm32.67 28.55c.22-11.86-15.14-10.37-15.98-.24-.61 9.51 16.36 10.44 15.98.24ZM27.16 53.2c11.51.08 10.71-15.05.19-15.99-9.84-.45-9.97 16.55-.19 15.99Zm.05 11.99c-9.84-.61-9.72 16.35.08 15.99 10.5-.86 11.44-16-.08-15.99Z" />
	</svg>
);

export default ThemesIcon;
